/* MAIYKO EKLENTI — Sepet "Beraber Tercih Edilenler" davranışı (24 Ağu 2026)
   Onaylı tasarım: addon kartı dili — Beden/Renk yüzer menüleri + görsel 1↔2.

   TASARIM NOTLARI:
   - cart-upsell.js sepet her değiştiğinde #cart-drawer-upsell-wrapper'ı yeni
     HTML ile DEĞİŞTİRİYOR; bu yüzden buradaki her şey document üzerinde
     DELEGASYONLA çalışır ve kart durumu DOM'dan/JSON'dan yeniden okunur.
   - Sepete ekleme temanın <product-form> makinesine bırakılır ("+" butonu
     form submit'idir); burada yalnız gizli id alanı güncellenir.
   - Menü, kartı İTMEZ: #cart-drawer-upsell köküne absolute konumlanır. */

(function () {
  'use strict';

  if (window.__maiykoUpsellKurulu) return;
  window.__maiykoUpsellKurulu = true;

  var FADE_MS = 3500;

  /* ---- yardımcılar ---- */

  function kok() {
    return document.getElementById('cart-drawer-upsell');
  }

  function veriOku(kart) {
    var s = kart.querySelector('[data-musell-veri]');
    if (!s) return null;
    var d;
    try {
      d = JSON.parse(s.textContent);
    } catch (e) {
      return null;
    }
    return d;
  }

  /* Kartın İLK (kendi ürünü) hâli — renk geri dönüşü için DOM'dan alınır.
     Wrapper her sepette yenilendiği için snapshot her kart ömründe taze. */
  function kendiKaydi(kart, d) {
    if (kart.__muKendi) return kart.__muKendi;
    var img1 = kart.querySelector('.musell-img1');
    var img2 = kart.querySelector('.musell-img2');
    var ad = kart.querySelector('[data-musell-ad]');
    var mini = kart.querySelector('[data-musell-mini] img');
    var renkDeger = kart.querySelector('[data-musell-renk-deger]');
    kart.__muKendi = {
      i: d ? d.c : 0,
      t: ad ? ad.textContent.replace(/^\s+|\s+$/g, '') : '',
      u: ad ? ad.getAttribute('href') : '',
      n: renkDeger ? renkDeger.textContent.replace(/^\s+|\s+$/g, '') : '',
      s: mini ? mini.getAttribute('src') : '',
      m1: img1 ? img1.getAttribute('src') : '',
      m2: img2 ? img2.getAttribute('src') : '',
      p: (kart.querySelector('[data-musell-fiyat]') || {}).textContent || '',
      o: (kart.querySelector('[data-musell-eski]') || {}).textContent || '',
      b: (kart.querySelector('[data-musell-rozet]') || {}).textContent || '',
      v: d ? d.v : []
    };
    return kart.__muKendi;
  }

  function aktifVaryantlar(kart, d) {
    var aktifId = parseInt(kart.getAttribute('data-mu-aktif') || '0', 10) || (d ? d.c : 0);
    if (d && aktifId !== d.c) {
      for (var i = 0; i < d.g.length; i++) {
        if (d.g[i].i === aktifId && d.g[i].v) return d.g[i].v;
      }
    }
    return kendiKaydi(kart, d).v || [];
  }

  /* ---- menü ---- */

  var acikMenu = null;
  var acikBtn = null;
  var menuAcilisMs = 0;

  function menuKapat() {
    if (acikMenu && acikMenu.parentNode) acikMenu.parentNode.removeChild(acikMenu);
    if (acikBtn) {
      acikBtn.classList.remove('is-acik');
      acikBtn.setAttribute('aria-expanded', 'false');
    }
    acikMenu = null;
    acikBtn = null;
  }

  function ogeYap(sinif, icHtml) {
    var el = document.createElement('div');
    el.className = sinif;
    el.innerHTML = icHtml;
    return el;
  }

  function metin(t) {
    var s = document.createElement('span');
    s.textContent = t == null ? '' : String(t);
    return s.innerHTML;
  }

  function menuAc(btn, kart, tip) {
    var d = veriOku(kart);
    if (!d) return;
    var kokEl = kok();
    if (!kokEl) return;

    var m = document.createElement('div');
    m.className = 'musell-menu';
    m.setAttribute('role', 'listbox');

    if (tip === 'beden') {
      m.appendChild(ogeYap('musell-menu__baslik', 'Beden'));
      var secilenId = parseInt((kart.querySelector('[data-musell-id]') || {}).value || '0', 10);
      var vars = aktifVaryantlar(kart, d);
      vars.forEach(function (v) {
        var yok = v.a !== 1;
        var o = ogeYap(
          'musell-menu__oge' + (yok ? ' musell-menu__oge--yok' : '') + (v.i === secilenId ? ' musell-menu__oge--secili' : ''),
          '<span class="musell-menu__ad">' + metin(v.t) + '</span>' +
            (yok ? '<span class="musell-menu__yok">Stok tükendi</span>' : v.i === secilenId ? '<span class="musell-menu__tik">✓</span>' : '')
        );
        if (!yok) {
          o.addEventListener('click', function () {
            var girdi = kart.querySelector('[data-musell-id]');
            if (girdi) girdi.value = String(v.i);
            var deger = kart.querySelector('[data-musell-beden-deger]');
            if (deger) deger.textContent = v.t;
            menuKapat();
          });
        }
        m.appendChild(o);
      });
    } else {
      m.appendChild(ogeYap('musell-menu__baslik', 'Renk — Aynı Gruptaki Modeller'));
      var aktifId = parseInt(kart.getAttribute('data-mu-aktif') || '0', 10) || d.c;
      var kendi = kendiKaydi(kart, d);
      d.g.forEach(function (uye) {
        var u = uye.k === 1 ? kendi : uye;
        if (!u || !u.n) return;
        var yok = uye.k === 1 ? false : uye.a !== 1;
        var seciliMi = (uye.k === 1 ? d.c : uye.i) === aktifId;
        var o = ogeYap(
          'musell-menu__oge' + (yok ? ' musell-menu__oge--yok' : '') + (seciliMi ? ' musell-menu__oge--secili' : ''),
          '<span class="musell-menu__mini">' + (u.s ? '<img src="' + metin(u.s) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="musell-menu__ad">' + metin(u.n) + '</span>' +
            (yok ? '<span class="musell-menu__yok">Stok tükendi</span>' : seciliMi ? '<span class="musell-menu__tik">✓</span>' : '')
        );
        if (!yok && !seciliMi) {
          o.addEventListener('click', function () {
            renkSec(kart, d, uye);
            menuKapat();
          });
        }
        m.appendChild(o);
      });
    }

    kokEl.appendChild(m);
    var bR = btn.getBoundingClientRect();
    var kR = kokEl.getBoundingClientRect();
    m.style.left = '12px';
    m.style.right = '12px';
    /* Alt karttaki menü kaydırma alanının dışında kalıp GÖRÜNMÜYORDU:
       aşağıda yer yoksa menü butonun ÜSTÜNE açılır. */
    var kapsayici = btn.closest('.cart-drawer-items-wrapper');
    var kapRect = kapsayici ? kapsayici.getBoundingClientRect() : null;
    var altSinir = kapRect ? kapRect.bottom : (window.innerHeight || 0);
    var ustSinir = kapRect ? kapRect.top : 0;
    var menuBoy = m.offsetHeight || 0;
    /* Menü, kaydırma alanının GÖRÜNÜR sınırları içinde kalacak yöne açılır;
       iki yöne de tam sığmıyorsa geniş olan yön seçilip yükseklik o boşluğa
       KISITLANIR (menü zaten overflow-y:auto, içerik kayar). */
    var altBosluk = altSinir - bR.bottom - 12;
    var ustBosluk = bR.top - ustSinir - 12;
    var yukari = false;
    if (menuBoy <= altBosluk) {
      yukari = false;
    } else if (menuBoy <= ustBosluk) {
      yukari = true;
    } else if (ustBosluk > altBosluk) {
      yukari = true;
      m.style.maxHeight = Math.max(120, Math.floor(ustBosluk)) + 'px';
      menuBoy = m.offsetHeight || menuBoy;
    } else {
      m.style.maxHeight = Math.max(120, Math.floor(altBosluk)) + 'px';
    }
    if (yukari) {
      m.style.top = Math.round(bR.top - kR.top - menuBoy - 6) + 'px';
    } else {
      m.style.top = Math.round(bR.bottom - kR.top + 6) + 'px';
    }

    btn.classList.add('is-acik');
    btn.setAttribute('aria-expanded', 'true');
    acikMenu = m;
    acikBtn = btn;
    menuAcilisMs = window.performance && performance.now ? performance.now() : 0;
  }

  /* ---- renk geçişi: kartın kimliğini kardeş modele çevirir ---- */

  function renkSec(kart, d, uye) {
    var kendi = kendiKaydi(kart, d);
    var u = uye.k === 1 ? kendi : uye;
    var hedefId = uye.k === 1 ? d.c : uye.i;

    var ad = kart.querySelector('[data-musell-ad]');
    if (ad) {
      ad.textContent = u.t || kendi.t;
      if (u.u) ad.setAttribute('href', u.u);
    }
    var img1 = kart.querySelector('.musell-img1');
    var img2 = kart.querySelector('.musell-img2');
    var alan = kart.querySelector('[data-musell-img]');
    if (img1 && u.m1) img1.src = u.m1;
    if (alan) {
      if (u.m2 && img2) {
        img2.src = u.m2;
        alan.classList.add('musell-img--fade');
      } else if (!u.m2) {
        alan.classList.remove('musell-img--fade', 'is-alt');
      }
    }
    var f = kart.querySelector('[data-musell-fiyat]');
    if (f) f.textContent = u.p || '';
    var e = kart.querySelector('[data-musell-eski]');
    if (e) {
      e.textContent = u.o || '';
      e.hidden = !u.o;
    }
    var r = kart.querySelector('[data-musell-rozet]');
    if (r) {
      r.textContent = u.b || '';
      r.hidden = !u.b;
    }
    var mini = kart.querySelector('[data-musell-mini]');
    if (mini) {
      mini.innerHTML = u.s ? '<img src="' + metin(u.s) + '" alt="" loading="lazy">' : '';
    }
    var renkDeger = kart.querySelector('[data-musell-renk-deger]');
    if (renkDeger) renkDeger.textContent = u.n || '';

    /* Varyant: müsait ilk varyanta geç, beden etiketi güncelle. */
    var vars = u.v || [];
    var secim = null;
    for (var i = 0; i < vars.length; i++) {
      if (vars[i].a === 1) {
        secim = vars[i];
        break;
      }
    }
    if (!secim && vars.length) secim = vars[0];
    var girdi = kart.querySelector('[data-musell-id]');
    if (girdi && secim) girdi.value = String(secim.i);
    var bedenDeger = kart.querySelector('[data-musell-beden-deger]');
    if (bedenDeger && secim) bedenDeger.textContent = secim.t;

    kart.setAttribute('data-mu-aktif', String(hedefId));
  }

  /* ---- delegasyon ---- */

  document.addEventListener('click', function (e) {
    var hedef = e.target;
    var btn = hedef && hedef.closest ? hedef.closest('[data-musell-sec]') : null;
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var kart = btn.closest('[data-musell-kart]');
      var acikTekrar = acikBtn === btn;
      menuKapat();
      if (!acikTekrar && kart) menuAc(btn, kart, btn.getAttribute('data-musell-sec'));
      return;
    }
    if (acikMenu && hedef && hedef.closest && hedef.closest('.musell-menu')) return;
    menuKapat();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') menuKapat();
  });

  /* Çekmece içi kaydırmada menü sabit kalamaz — kapat. */
  document.addEventListener(
    'scroll',
    function (e) {
      if (!acikMenu) return;
      /* Kaydırma olayları ASENKRON gelir: menü açılmadan önceki kaydırmanın
         olayı açılıştan hemen sonra ulaşıp menüyü anında kapatıyordu (canlıda
         @46ms yakalandı). Açılışı izleyen ilk 300ms'lik scroll yok sayılır. */
      if (window.performance && performance.now && performance.now() - menuAcilisMs < 300) return;
      if (!e.target || !e.target.closest) return;
      /* v15: menünün KENDİ içindeki kaydırma menüyü kapatmasın (Yusuf: "beden/renk seçeneğini kaydıramıyorum"). */
      if (e.target.closest('.musell-menu')) return;
      if (e.target.closest('.cart-drawer-items-wrapper') || (e.target.classList && e.target.classList.contains('musell-liste'))) menuKapat();
    },
    true
  );

  /* ---- sepete ekleme: AJAX (product-form.js ürün sayfası dışında yok) ----
     "+" formunun submit'i yakalanır; /cart/add.js + Section Rendering ile
     çekmece YERİNDE yenilenir (tam sayfa /cart yönlendirmesi olmaz).
     cart-drawer.renderContents yoksa son çare sayfa yenilenir. */

  function bolumIdleri(cartEl) {
    try {
      if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
        return cartEl.getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) {
      /* yoksay */
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  /* CAPTURE fazı + stopImmediatePropagation: temanın product-form.js'i aynı submit'i
     ikinci kez /cart/add.js'e göndermesin (v15 çift ekleme düzeltmesi). */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('.musell-form')) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    var girdi = form.querySelector('[data-musell-id]');
    var btn = form.querySelector('.musell-arti');
    if (!girdi || form.getAttribute('data-mu-mesgul') === '1') return;
    form.setAttribute('data-mu-mesgul', '1');
    if (btn) {
      btn.setAttribute('aria-busy', 'true');
      btn.style.opacity = '0.6';
    }

    var cartEl = document.querySelector('cart-drawer');
    var gövdesizId = parseInt(girdi.value, 10);

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: gövdesizId, quantity: 1 }],
        sections: bolumIdleri(cartEl),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (yanit) {
        if (yanit && yanit.status) {
          /* 422 vb. — buton eski hâline döner, gezinme yok. */
          return;
        }
        menuKapat();
        if (cartEl && typeof cartEl.renderContents === 'function') {
          cartEl.renderContents(yanit);
          if (typeof cartEl.open === 'function' && cartEl.classList && !cartEl.classList.contains('active')) {
            try { cartEl.open(); } catch (e2) { /* yoksay */ }
          }
        } else {
          window.location.reload();
        }
      })
      .catch(function () { /* ağ hatası: sessiz, buton geri açılır */ })
      .then(function () {
        form.removeAttribute('data-mu-mesgul');
        if (btn) {
          btn.removeAttribute('aria-busy');
          btn.style.opacity = '';
        }
      });
  }, true);

  /* ---- sayfa noktaları: kaç 2'li sayfa varsa o kadar nokta; kaydırınca
     aktif nokta değişir, noktaya tıklayınca o sayfaya kayar. Wrapper her
     sepet değişiminde yenilendiği için periyodik olarak yeniden kurulur. ---- */

  function aktifSayfa(liste, sayfaSayisi) {
    var max = liste.scrollWidth - liste.clientWidth;
    if (max <= 0 || sayfaSayisi < 2) return 0;
    var idx = Math.round((liste.scrollLeft / max) * (sayfaSayisi - 1));
    return Math.max(0, Math.min(sayfaSayisi - 1, idx));
  }

  function noktalariBoya(dots, aktif) {
    for (var i = 0; i < dots.children.length; i++) {
      dots.children[i].className = 'musell-nokta' + (i === aktif ? ' musell-nokta--aktif' : '');
    }
  }

  function noktalariKur(liste) {
    var satir = liste.classList && liste.classList.contains('musell-liste--cift') ? 2 : 1;
    var sayfa = Math.ceil(liste.querySelectorAll('.musell-kart').length / satir);
    var dots = liste.nextElementSibling;
    var varMi = dots && dots.classList && dots.classList.contains('musell-noktalar');
    if (sayfa < 2) {
      if (varMi) dots.parentNode.removeChild(dots);
      return;
    }
    if (varMi && dots.children.length === sayfa) return;
    if (varMi) dots.parentNode.removeChild(dots);

    dots = document.createElement('div');
    dots.className = 'musell-noktalar';
    for (var i = 0; i < sayfa; i++) {
      (function (idx) {
        var n = document.createElement('button');
        n.type = 'button';
        n.className = 'musell-nokta';
        n.setAttribute('aria-label', 'Sayfa ' + (idx + 1));
        n.addEventListener('click', function () {
          var max = liste.scrollWidth - liste.clientWidth;
          var hedef = sayfa > 1 ? (idx / (sayfa - 1)) * max : 0;
          if (typeof liste.scrollTo === 'function') liste.scrollTo({ left: hedef, behavior: 'smooth' });
          else liste.scrollLeft = hedef;
        });
        dots.appendChild(n);
      })(i);
    }
    liste.parentNode.insertBefore(dots, liste.nextSibling);
    noktalariBoya(dots, aktifSayfa(liste, sayfa));

    liste.addEventListener('scroll', function () {
      noktalariBoya(dots, aktifSayfa(liste, sayfa));
    });
  }

  if (typeof window.setInterval === 'function') {
    window.setInterval(function () {
      var listeler = document.querySelectorAll('.musell-liste');
      for (var i = 0; i < listeler.length; i++) {
        if (listeler[i].offsetParent !== null) noktalariKur(listeler[i]);
      }
    }, 700);
  }

  /* ---- görsel 1↔2 geçişi (addon'la aynı ritim; kaymayı --mu-fd verir) ---- */

  if (typeof window.setInterval === 'function') {
    window.setInterval(function () {
      var alanlar = document.querySelectorAll('.musell-img--fade');
      for (var i = 0; i < alanlar.length; i++) {
        alanlar[i].classList.toggle('is-alt');
      }
    }, FADE_MS);
  }
})();
